import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';
import { logEvent } from './utils/logEvent';

const VerifyOTP = ({ setAuthUsername, setIsAuthenticated }) => {
    const [otp, setOtp] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleVerify = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const tempToken = sessionStorage.getItem('temp_token');
            const username = sessionStorage.getItem('username_2fa');
            if (!tempToken) {
                setError('Your session expired. Please log in again.');
                navigate('/login');
                return;
            }

            const response = await fetch('/api/2fa/verify', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${tempToken}`
                },
                body: JSON.stringify({ otp })
            });

            if (response.ok) {
                logEvent('login_success', { method: '2fa_otp', username }).catch(() => {});
                setAuthUsername(username || '');
                setIsAuthenticated(true);
                try { sessionStorage.setItem('tab_session', '1'); } catch (e) { /* ignore */ }
                sessionStorage.removeItem('temp_token');
                sessionStorage.removeItem('username_2fa');
                navigate('/');
            } else {
                const data = await response.json().catch(() => ({}));
                setError(data.error || 'Invalid code. Please try again.');
                logEvent('login_2fa_failure', { stage: 'verify', error: data.error }).catch(() => {});
            }
        } catch (err) {
            setError('Network error. Please try again.');
            logEvent('login_2fa_failure', { stage: 'verify', error: err?.message || 'network_error' }).catch(() => {});
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <form onSubmit={handleVerify} className="login-form">
                <h2>Verify One-Time Password</h2>
                <p>Enter the 6-digit code from your authenticator app.</p>
                {error && <div className="error">{error}</div>}

                <div className="form-section">
                    <label htmlFor="otp">One-Time Password</label>
                    <input
                        id="otp"
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]{6}"
                        maxLength={6}
                        placeholder="123456"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value.replace(/\D/g, ''))}
                        required
                        autoComplete="one-time-code"
                        disabled={loading}
                    />
                </div>

                <button type="submit" disabled={loading || otp.length !== 6}>
                    {loading ? 'Verifying…' : 'Verify & Continue'}
                </button>

                <div style={{ marginTop: 12, textAlign: 'center' }}>
                    <button
                        type="button"
                        className="link-button"
                        onClick={() => navigate('/login')}
                        disabled={loading}
                    >
                        Use a different account
                    </button>
                </div>
            </form>
        </div>
    );
};

export default VerifyOTP;